/* eslint-disable react/jsx-wrap-multilines */
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import H2 from '@base/H2/H2';
import H6 from '@base/H6/H6';
import P1 from '@base/P1/P1';
import TextField from '@base/TextField/TextField';
import Button from '@base/Button/Button';
import { getPasswordError } from '@utils/formHelper';
import { Spacings, Fonts, BgColors, TextColors } from '@styles/index';
import EnterOtherFields from './EnterOtherFields';

const StyledP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_4B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      margin: 16px 0;
  };`}
`;

const StyledTextField = styled(TextField)`
  margin-top: ${Spacings.SPACING_4B};
`;

const DisabledTextField = styled(TextField)`
  background: ${BgColors.DISABLED};
`;

const StyledUnderlineLink = styled(UnderlineLink)`
  position: absolute;
  border-bottom-width: 0;
  padding-bottom: 0;
  right: ${Spacings.SPACING_4B};
  top: 18px;
`;

const EditDiv = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  position: relative;
`;

const StyledH6 = styled(H6)`
  font-weight: ${Fonts.BOLD};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${Spacings.SPACING_8B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      margin-top: 16px;
  };`}
`;

const UnderlineLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Header = styled(H2)`
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      font-size: 16px;
  };`}
`;

const EnterPasswordStep = ({
  email,
  password,
  setPassword,
  fieldsData,
  // country,
  setFieldsData,
  editEmail,
  otpOrEmailResponse,
  submitLogin,
  loggingIn,
  states,
  error
}) => {
  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const shouldEnableSubmit = () => {
    let enabled = true;
    if (password === '') {
      enabled = false;
    }
    if (!otpOrEmailResponse.has_name && fieldsData.name.value.trim() === '') {
      enabled = false;
    }
    if (!otpOrEmailResponse.has_email && fieldsData.email.value.trim() === '') {
      enabled = false;
    }
    // Need to discuss the flow again with PMs
    // if (
    //   country?.code === 'IN' &&
    //   !otpOrEmailResponse.has_state &&
    //   fieldsData.state.value.trim() === ''
    // ) {
    //   enabled = false;
    // }
    return enabled;
  };
  const onButtonClick = (e) => {
    e.preventDefault();
    if (shouldEnableSubmit()) submitLogin();
  };

  const forgotPwd = (e) => {
    e.preventDefault();
    window.open(
      `https://learn.unacademy.com/forgot/password_reset?email=${email}`
    );
  };
  const { isPasswordError, passwordErrorMsg } = getPasswordError(error);
  return (
    <>
      <Header>Enter Password</Header>
      <StyledP1>
        Please enter password of your registered email address
      </StyledP1>
      <EditDiv>
        <DisabledTextField
          fullWidth
          value={email}
          type="email"
          disabled
          endAdornment={
            <InputAdornment>
              <StyledUnderlineLink onClick={editEmail} href="#">
                <StyledH6>Edit</StyledH6>
              </StyledUnderlineLink>
            </InputAdornment>
          }
        />
      </EditDiv>
      <form onSubmit={onButtonClick}>
        <StyledTextField
          fullWidth
          value={password}
          type="password"
          placeholder="Password"
          onChange={onPasswordChange}
          error={isPasswordError}
          helperText={passwordErrorMsg}
          autoFocus
        />
        <EnterOtherFields
          fieldsData={fieldsData}
          setFieldsData={setFieldsData}
          otpOrEmailResponse={otpOrEmailResponse}
          states={states}
          error={error}
        />
      </form>
      <ButtonWrapper>
        <Button
          variant={shouldEnableSubmit() && !loggingIn ? 'filled' : 'disabled'}
          label={loggingIn ? 'Submitting...' : 'Submit'}
          onClick={onButtonClick}
        />
        <UnderlineLinkWrapper>
          <UnderlineLink onClick={forgotPwd} href="#">
            <StyledH6 color={TextColors.BLACK}>Forgot Password?</StyledH6>
          </UnderlineLink>
        </UnderlineLinkWrapper>
      </ButtonWrapper>
    </>
  );
};

export default EnterPasswordStep;

EnterPasswordStep.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  fieldsData: PropTypes.objectOf(PropTypes.any).isRequired,
  setPassword: PropTypes.func.isRequired,
  setFieldsData: PropTypes.func.isRequired,
  // country: PropTypes.objectOf(PropTypes.any).isRequired,
  editEmail: PropTypes.func.isRequired,
  submitLogin: PropTypes.func.isRequired,
  loggingIn: PropTypes.bool.isRequired,
  otpOrEmailResponse: PropTypes.objectOf(PropTypes.any).isRequired,
  states: PropTypes.arrayOf(PropTypes.any).isRequired,
  error: PropTypes.arrayOf(PropTypes.any).isRequired
};
